import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { SButton, SIcon } from '@strana-artw/ui-kit';
import ContextPopover from '@/shared/ui/ContextPopover';
export default {
  name: 'SortingMenu',
  components: {
    SIcon: SIcon,
    SButton: SButton,
    ContextPopover: ContextPopover
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    current: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      showSort: false
    };
  },
  methods: {
    handleSortToggle: function handleSortToggle() {
      this.showSort = true;
    },
    handleSortChange: function handleSortChange(val) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return _this.$emit('sortChange', val);
            case 1:
              _this.showSort = false;
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};